/* eslint-disable no-underscore-dangle */
/* eslint-disable @microsoft/sdl/no-cookies */
import { CookieName } from '@jsmdg/cookie-generation/dist/types/cookieConfig';
import { USERCENTRICS_CONFIG_KEY_NAME } from '@jsmdg/cookie-generation/dist/types/usercentrics';
import { getUsercentricsSettings } from './getUserCentricsSettings';
import { type TcfDataType } from './types/tcfData';
import { type UsercentricSettingsType } from './types/usercentricsSettings';

window.addEventListener('load', () => {
    const usercentricsServiceTemplateId = Object.values(
        window.Evelin?.data?.julien?.usercentricsTrackingTemplateIds,
    );

    const usercentricsDyServiceId = window.Evelin?.data?.julien?.usercentricsTrackingTemplateIds.dy;

    // we need this in order to send the usercentrics cookie consent information via the request to the Lambda@Edge and Julien
    const usercentricsEventHandler = function (tcfData: TcfDataType, success: boolean): void {
        const usercentricsSettings: string | undefined = getUsercentricsSettings();

        const areUsercentricsSettingsReady =
            success && usercentricsSettings && tcfData.eventStatus === 'useractioncomplete';

        if (!areUsercentricsSettingsReady) {
            return;
        }

        const usercentricsSettingsObject = JSON.parse(
            usercentricsSettings,
        ) as UsercentricSettingsType;

        const filteredUsercentricsServices = usercentricsSettingsObject.services
            ?.map(service =>
                usercentricsServiceTemplateId.includes(service.id)
                    ? { id: service.id, status: service.status }
                    : null,
            )
            .filter(Boolean);

        if (!filteredUsercentricsServices?.length) {
            return;
        }

        const dyService = filteredUsercentricsServices.find(
            service => service?.id === usercentricsDyServiceId,
        );

        // update dynamic yield consent status
        window.DYO.ActiveConsent.updateConsentAcceptedStatus(!!dyService?.status);
        window.DY.userActiveConsent = !!dyService?.status;
        if (!dyService?.status) {
            document.cookie = `${CookieName.dyServer}=; Max-Age=0; path=/;`;
        }

        const cookieDate = new Date();
        cookieDate.setFullYear(cookieDate.getFullYear() + 1);
        document.cookie = `${USERCENTRICS_CONFIG_KEY_NAME}=${JSON.stringify(
            filteredUsercentricsServices,
        )}; expires=${cookieDate.toUTCString()}; path=/;`;

        // eslint-disable-next-line no-void
        void fetch(window.location.href, {
            method: 'HEAD',
            // we need to send the original referer as a query param to not loose it
            // its called referer instead of referrer here, since the cookie-generation-js library is reading it and we only deal with "referer" there
            referrer:
                document.referrer && document.referrer !== window.location.origin
                    ? `${window.location.origin}?original_referer=${document.referrer}`
                    : '',
        });
    };

    window.__tcfapi?.('addEventListener', 2, (tcfData: TcfDataType, success: boolean) => {
        setTimeout(() => usercentricsEventHandler(tcfData, success), 500);
    });
});
